import {
    compact,
    dark,
} from './config.defaults'

import {
    embedDarkDefault, embedDefault,
} from './config.embed'

import {createTheme} from './config'


export const darkTheme = createTheme('dark', dark)

export const compactTheme = createTheme('compact', compact)

export const embedTheme = createTheme('embed', embedDefault)

export const embedDarkTheme = createTheme('embedDark', embedDarkDefault)
